
<template>
  <header class="mainHeader download" style="-webkit-text-size-adjust: none;">
    <div class="flex items-center justify-between px-2 header-nav ">
      <div class="clearfix searchNav">
        <a class="fl headLogo" href="/">
          <!-- <img src="../../assets/images/common/logoOuter.png" /> -->
        </a>
      </div>
    </div>
  </header>
</template>

<script lang="ts" setup>
onMounted(()=>{
  const bodyEl = document.querySelector('body')
  console.log(bodyEl)
  if(bodyEl){
    bodyEl.style.overflowX = 'hidden'
  }
})

</script>
